;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="e5f601eb-c2f3-4154-8737-cc3e22c8089a",e._sentryDebugIdIdentifier="sentry-dbid-e5f601eb-c2f3-4154-8737-cc3e22c8089a")}catch(e){}}();import React__default, { useContext } from 'react';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { SentryBoundary } from '../../utils/SentryBoundary.js';
import styles from './BonusPointsBanner.module.scss.js';
import getBonusPoints from './BonusPointsWrapper.js';

function BonusPointsBanner() {
    const { isNextJS, domain } = useContext(AppContext);
    const BonusPointsBox = React__default.useMemo(() => getBonusPoints(isNextJS), []);
    return (React__default.createElement(SentryBoundary, null,
        React__default.createElement("li", { className: styles.bpWrapper },
            React__default.createElement(BonusPointsBox, { siteDomain: domain, location: "shop-header" }))));
}

export { BonusPointsBanner as default };
//# sourceMappingURL=BonusPointsBanner.js.map
